import React from "react";
import Header from "../../components/common/Header";

const HeroSection = () => {
  return (
    <section className="w-full relative">
      <div className="relative w-full">
        {/* Background Image */}
        <div className="absolute w-full top-0 ">
          <Header />
        </div>
        <div className="pt-[50px]">
          <img
            src="/assets/productImg/products.png"
            alt="Background"
            className="relative inset-0 w-full h-full object-cover z-0"
          />
        </div>
        {/* Decorative Image */}
        {/* <img
          src="/images/img_rectangle_64.png"    
          alt="Decorative"
          className="absolute top-0 left-[6%] w-[94%] h-[600px] sm:h-[800px] lg:h-[1120px] object-cover z-10"
        /> */}

        {/* Content Container */}
      </div>
    </section>
  );
};

export default HeroSection;
